import { render, staticRenderFns } from "./CollaborateurDashboard.vue?vue&type=template&id=155cfeba&"
import script from "./CollaborateurDashboard.vue?vue&type=script&lang=js&"
export * from "./CollaborateurDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports